var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('el-switch',_vm._b({attrs:{"value":_vm.value,"activeValue":_vm.activeValue,"inactiveValue":_vm.inactiveValue},on:{"change":_vm.change}},'el-switch',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }